import * as types from '@/store/mutation-types'

export default {
  [types.SET_LOCATIONS] (state, locations) {
    state.locations = locations
  },
  [types.SET_MESSAGE_SEND_STATUS] (state, status) {
    state.messageSendingStatus = status
  },
  [types.SET_PARENT_SIZE_INFO] (state, parentSizeInfo) {
    state.isMobile = parentSizeInfo.clientWidth < 600
    state.parentHeight = parentSizeInfo.clientHeight
    state.parentWidth = parentSizeInfo.clientWidth
  },
  [types.SET_WIDGET_SETTINGS] (state, widgetSettings) {
    const webToTextSettings = { color_primary: 'colorPrimary', color_text: 'colorText' }

    widgetSettings.map(ws => {
      state.customSettings[webToTextSettings[ws.setting_name]] = ws.setting_value
    })
  }
}
